/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2026 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2026 - Finnish Meteorological Institute (FMI)
 * Copyright 2026 - The Norwegian Meteorological Institute (MET Norway)
 * */

export interface TimeMismatchInfo {
  mismatch: true;
}

export const getTimeMismatchInfo = (
  isTimeSynced: boolean,
  warningTimeInUse: string | undefined,
  sourceTimesteps: string[][],
): TimeMismatchInfo | undefined => {
  if (!isTimeSynced || !warningTimeInUse) {
    return undefined;
  }

  const requestedTimestamp = new Date(warningTimeInUse).getTime();
  const allSourceTimesteps = sourceTimesteps
    .flat()
    .map((timestep) => new Date(timestep).getTime())
    .filter((time) => Number.isFinite(time))
    .sort((aTime, bTime) => aTime - bTime);

  if (allSourceTimesteps.length === 0) {
    return undefined;
  }

  const firstAvailableTime = allSourceTimesteps[0];
  const lastAvailableTime = allSourceTimesteps[allSourceTimesteps.length - 1];
  const isOutsideOverallSoundingsRange =
    requestedTimestamp < firstAvailableTime ||
    requestedTimestamp > lastAvailableTime;

  return isOutsideOverallSoundingsRange ? { mismatch: true } : undefined;
};
